import { IAPIBestSold, IBestSold } from './IBestSold'

class Transformer {
    static transform(sold: IAPIBestSold[]): IBestSold[] {
        return sold.map((item) => {
            return {
                amountSold: item.amount_sold,
                product: {
                    id: item.product.id,
                    name: item.product.name,
                    categoryId: item.product.category_id,
                    code: item.product.code,
                    barcode: item.product.barcode,
                    previousBarcode: item.product.previous_barcode,
                    imageId: item.product.image_id,
                    purchasePrice: item.product.purchase_price,
                    salePrice: item.product.sale_price,
                    inStock: item.product.in_stock,
                    minStock: item.product.min_stock,
                    maxStock: item.product.max_stock,
                },
            }
        })
    }
}

export default Transformer
